import React from "react";
import Server from "../../img/Server-cuate.png";
import Market from "../../img/marketplace-amico.png";

export default function Content() {
  return (
    <>
      {/* src="https://flowbite.com/docs/images/carousel/carousel-3.svg" */}
      <div>
        <div className="pb-40 max-w-2xl mx-auto px-4 grid items-center grid-cols-1 gap-y-16 gap-x-8 sm:px-6 lg:max-w-7xl lg:px-8 lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              General Information
            </h2>
            <p className="mt-4 text-gray-500">
              The system is running on Amazon servers with a 24/7 microservices
              infrastructure.
              <br /> A robot starts working for each user separately so that it
              can fulfill all user requests without any problems.
            </p>

            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Server Speed</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  Our system uses Amazon's servers to perform all the buying and
                  selling tasks with high speed.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Server Security</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  Amazon servers have the latest security methods to prevent
                  DDoS, Database and etc attacks.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">
                  Server Working Hours
                </dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The server and robots are doing all the buying and selling
                  things 24 hours a day.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Dedicated Servers</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  Servers and bots are designed in such a way that the required
                  server is assigned to each user separately..
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Cost of Servers</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The servers and bots assigned are free for users and a small
                  part of the profit from purchases and sales is given to the
                  servers.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">
                  Profitability of Servers
                </dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The profit of the users is from the automatic purchases and
                  sales made by the robots.
                </dd>
              </div>
            </dl>
          </div>
          <div className="grid grid-cols-1 grid-rows1 gap-4 sm:gap-6 lg:gap-8">
            <img
              src={Server}
              alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
              className="bg-gray-100 rounded-lg"
            />
          </div>
        </div>
      </div>

      <div>
        <div className="max-w-2xl mx-auto pb-24 px-4 grid items-center grid-cols-1 gap-y-16 gap-x-8 sm:px-6 sm:pb-32 lg:max-w-7xl lg:px-8 lg:grid-cols-2">
          <div className="grid grid-cols-1 grid-rows1 gap-4 sm:gap-6 lg:gap-8">
            <img
              src={Market}
              alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
              className="bg-gray-100 rounded-lg"
            />
          </div>
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Supported Platforms
            </h2>
            <p className="mt-4 text-gray-500">
              Our system supports Amazon, Etsy, AliExpress, Joom, Qoo10 and
              Disney stores.
              <br />
              We are trying to have a high score and purchase using the
              platforms mentioned in them.
            </p>

            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Amazon</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  Buying and selling, returning orders by designed robots, the
                  possibility of making 1,000,000 requests per day.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Etsy</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The Drop Shipping system and selling products and
                  advertisements by designed robots.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">AliExpress</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The Drop Shipping system, buying and selling products and
                  advertisements by designed robots.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Joom & Qoo10</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  The Drop Shipping system, buying and selling products and
                  advertisements by designed robots.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Disney</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  For the first time, it is possible to buy and sell the Disney
                  Media stock by investing in Disney Media.
                </dd>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <dt className="font-medium text-gray-900">Coming soon</dt>
                <dd className="mt-2 text-sm text-gray-500">
                  Alibaba, Bonanza and Trendyol stores will enter the system
                  soon, we will provide the possibility of more income for
                  users.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
